<div
  class="header h-[55px] flex justify-start items-center pl-[50px] mb-[18px] bg-[#F1F3F5]"
>
  <p class="!m-0">{{ projectName }} - {{labels.title}}</p>
  <p
    class="text-[#343A40] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] !w-[150px] !h-[19px] flex items-center justify-center"
  >
    Contractual Terms
  </p>
</div>
     

<!-- Submission Address  -->
<div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
  <div class="p-0">
    <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
      <mat-form-field class="!w-[450px]" appearance="outline">
        <mat-label> Insert Contract Type </mat-label>
        <input
          matInput
          type="text"
          [formControl]="contractTypeDetailsControl"
          placeholder="Insert Contract Type"
        />
      </mat-form-field>
      <mat-error
            *ngIf="contractTypeDetailsControl.invalid && contractTypeDetailsControl.touched"
        class="relative top-[-15px]"
      >
        Insert Contract Type is required.
      </mat-error>
    </div>
  </div>
</div>
<!--Upload File Drag and Drop -->
<div class="flex flex-col items-start">
  <div class="bg-[#f7f6fb] ml-[50px]">
    <div
      class="flex w-[81vw] h-[122px] flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 hover:bg-gray-100"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
      [class.bg-blue-50]="isDragging"
    >
            <svg
              width="34"
              height="37"
              viewBox="0 0 34 37"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.9738 12.5093V23.3921C14.9743 23.8544 15.1513 24.2991 15.4687 24.6352C15.786 24.9714 16.2198 25.1737 16.6813 25.2008C17.1428 25.2279 17.5972 25.0777 17.9518 24.781C18.3063 24.4843 18.5341 24.0634 18.5887 23.6043L18.6014 23.3921V12.5093H29.4842C30.3994 12.509 31.2809 12.8547 31.952 13.477C32.6231 14.0993 33.0341 14.9522 33.1027 15.8648L33.1118 16.1369V32.4611C33.1121 33.3763 32.7665 34.2578 32.1442 34.9289C31.5219 35.6 30.6689 36.011 29.7563 36.0797L29.4842 36.0887H4.09098C3.17578 36.089 2.29429 35.7434 1.62322 35.1211C0.952145 34.4988 0.541088 33.6458 0.472448 32.7332L0.463379 32.4611V16.1369C0.463089 15.2217 0.808739 14.3402 1.43104 13.6691C2.05334 12.9981 2.90629 12.587 3.81891 12.5184L4.09098 12.5093H14.9738ZM18.391 0.663368L24.4836 6.75412C24.8239 7.09446 25.0151 7.55606 25.0151 8.03738C25.0151 8.5187 24.8239 8.9803 24.4836 9.32065C24.1432 9.66099 23.6816 9.85219 23.2003 9.85219C22.719 9.85219 22.2574 9.66099 21.917 9.32065L18.6014 6.0032V12.5093H14.9738V6.0032L11.6582 9.32065C11.4896 9.48917 11.2896 9.62284 11.0694 9.71405C10.8492 9.80525 10.6132 9.85219 10.3749 9.85219C10.1366 9.85219 9.90059 9.80525 9.6804 9.71405C9.46022 9.62284 9.26016 9.48917 9.09164 9.32065C8.92311 9.15213 8.78944 8.95206 8.69823 8.73188C8.60703 8.5117 8.56009 8.27571 8.56009 8.03738C8.56009 7.79906 8.60703 7.56307 8.69823 7.34288C8.78944 7.1227 8.92311 6.92264 9.09164 6.75412L15.186 0.663368C15.6111 0.238601 16.1875 0 16.7885 0C17.3895 0 17.9659 0.238601 18.391 0.663368Z"
                fill="#2368A2"
              />
            </svg>
      <button
        type="button"
        class="bg-[#D9D9D9] text-[#21252A] px-4 py-2 mt-5 rounded hover:bg-[#F1F3F5] focus:outline-none"
        (click)="fileInputDocument.click()"
      >
        Attach File
      </button>
      <p class="text-lg font-semibold  text-[#343A40]">Drag & Drop</p>

      <input
        type="file"
        #fileInputDocument
        (change)="onFileUpload($event, false)"
        multiple
        hidden
      />
    </div>
  </div>
  <div class="flex flex-col !pl-[50px]">
    <div
      *ngFor="let file of uploadedFiles; let i = index"
      class="flex items-start mt-[11px]"
    >
      <div class="flex justify-start items-center">
        <div
          class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
        >
          <ng-container>
            <img
              [src]="getFileIcon(file)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </ng-container>

          <!-- TODO: -->
                <ng-template #pdfIcon>
                </ng-template>
        </div>
      </div>
      <!-- File name under the image -->
      <div class="flex items-center">
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ file.name }}
        </span>
        <img
          (click)="removeFile(i)"
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-[13px] h-[100%] cursor-pointer ml-[8px] mt-[8px]"
        />
      </div>
    </div>

    <div
      *ngFor="let file of oldFiles; let i = index"
      class="flex items-start mt-[11px]"
    >
      <div class="flex justify-start items-center">
        <div
          class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
        >
                <ng-container >
            <img
              [src]="getFileIcon(file)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </ng-container>
        </div>
      </div>
      <!-- File name under the image -->
      <div class="flex items-center">
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ file.name }}
        </span>
        <img
          (click)="removeOldFile(file?.id)"
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto h-[100%] cursor-pointer ml-[8px] mt-[8px]"
        />
      </div>
    </div>
  </div>

</div>
<div class="flex flex-col p-5 pl-[51px] ">
  <p class="!pr-[20px]">
    The governing law for the contract will be [Insert Jurisdiction]. Tenderers
    are advised to review the draft contract terms included in this {{labels.rfpMode}} (Annex
    3) and provide comments if any deviations are proposed.  Key contract
    provisions (Empty Fields for Developer to Add) 
  </p>
  <ul>
    <li>Performance bonds and guarantees </li>
    <li>Liquidated damages for delays </li>
    <li>
      Insurance requirements (professional indemnity, public liability, all
      risks) 
    </li>
  </ul>
</div>

<!-- Back and next Buttons -->
<div
  class="!pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
>
  <div class="!w-[100%] flex justify-end items-center">
        <button (click)="handleBack()" type="button" class="back-btn">
          Back
        </button>
    <button
      class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[14px] !rounded-[3px]"
      style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
      (click)="moveToNextStep()"
    >
      Next
    </button>
  </div>
</div>

